import { HeaderAndFooter } from "./HeaderAndFooter";
import Error500 from "@JohnLewisPartnership/jl-design-system/dist/components/error-500/Error500";

export default function ErrorPage() {
  return (
    <HeaderAndFooter>
      <Error500 returnTo={<a href="/">the home page</a>} />
    </HeaderAndFooter>
  );
}
